// Module
var code = `<div id="menu-drawer-content">

    <a
            data-channel="ROUTE"
            data-page-id="home"
            data-event-prevent-default="true"
            class="menu-drawer-link nav-level-{{navLevel}}"
            href="/"
    >Home</a>

  {{#pageLinks}}
  <a
    data-channel="ROUTE"
    data-page-id="{{pageId}}"
    data-card-id="{{cardId}}"
    data-event-prevent-default="true"
    class="menu-drawer-link nav-level-{{navLevel}}"
    href="{{href}}"
    >{{title}}</a
  >

  {{/pageLinks}}
</div>
`;
// Exports
module.exports = code;